import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import AppFunction from "../../../core/helpers/app/AppFunction";
import {EMPLOYEES_PROFILE, LEADERBOARD} from "../../Config/ApiUrl";
import {
    DepartmentFilterMixin,
    DesignationFilterMixin,
    WorkingShiftFilterMixin,
    RoleFilterMixin,
    EmploymentStatusFilterMixin
} from "./FilterMixin"



import {axiosDelete, axiosPatch, urlGenerator} from "../../../common/Helper/AxiosHelper";
import {TENANT_USERS} from "../../../common/Config/apiUrl";
import {calenderTime} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin, DepartmentFilterMixin, DesignationFilterMixin, WorkingShiftFilterMixin, RoleFilterMixin, EmploymentStatusFilterMixin],
    data() {
        return {
            isModalActive: false,
            isEmployeeCreateOpenModalActive: false,
            employmentStatusModalActive: false,
            isTerminationReasonModalActive: false,
            promptIcon: '',
            promptTitle: '',
            promptMessage: '',
            modalClass: '',
            confirmationModalActive: false,
            promptAction: '',
            tenant: '',
            selectedUrl: '',
            employeeId: '',
            loading: false,
            attendanceModalActive: false,
            leaveModalActive: false,
            isJobHistoryEditModalActive: false,
            modalAction: '',
            options: {
                showSearch: true,
                showFilter: true,
                filters: [
                    // {
                    //     title: this.$t('created'),
                    //     type: "range-picker",
                    //     key: "date",
                    //     option: ["today", "thisMonth", "last7Days", "thisYear"]
                    // },
                    // {
                    //     title: this.$t('joining_date'),
                    //     key: "joining_date",
                    //     type: "range-picker",
                    //     option: ["today", "thisMonth", "last7Days", "thisYear"]
                    // },
                    // {
                    //     title: this.$t('designation'),
                    //     type: "multi-select-filter",
                    //     key: "designations",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_designations')
                    // },
                    // {
                    //     title: this.$t('employment_status'),
                    //     type: "multi-select-filter",
                    //     key: "employment_statuses",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_employment_statuses')
                    // },
                    // {
                    //     title: this.$t('department'),
                    //     type: "multi-select-filter",
                    //     key: "departments",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_departments')
                    // },
                    // {
                    //     title: this.$t('work_shift'),
                    //     type: "multi-select-filter",
                    //     key: "working_shifts",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_working_shifts')
                    // },
                    // {
                    //     title: this.$t('role'),
                    //     type: "multi-select-filter",
                    //     key: "roles",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_roles')
                    // },
                    // {
                    //     title: this.$t('gender'),
                    //     type: "checkbox",
                    //     key: "gender",
                    //     option: [
                    //         {id: 'male', value: this.$t('male')},
                    //         {id: 'female', value: this.$t('female')},
                    //         {id: 'other', value: this.$t('other')}
                    //     ],
                    //     permission: !!this.$can('view_employees')
                    // },
                ],
            },

            tableOptions: {
                name: this.$allLabel('employee'),
                url: LEADERBOARD,
                showCount: true,
                showClearFilter: true,
                enableRowSelect: true,
                datatableWrapper: false,
                showHeader: true,
                responsive: true,
                tablePaddingClass: "px-0",
                showSearch: false,
                showFilter: false,
                tableShadow: false,

                columns: [
                    {
                        title: this.$t('rank'),
                        type: 'custom-html',
                        key: 'rank',
                        isVisible: true,
                        modifier: (rank, row) => {
                            // return ((row.rank_arrow === "up" ? `${rank}  <i class="fa fa-arrow-trend-up text-success"></i>` : ( row.rank_arrow === "down" ?  `${rank} <i class="fa fa-arrow-trend-down text-danger"></i>` : rank))) ;
                            return ((row.rank_arrow === "up" ? `${rank}  <i class="ml-2 fa fa-sort-amount-up text-success"></i>` : ( row.rank_arrow === "down" ?  `${rank} <i class="ml-2 fa fa-sort-amount-down text-danger"></i>` : rank))) ;
                        }
                    },
                    {
                        title: this.$t('percentile'),
                        type: 'custom-html',
                        key: 'rank_percentile',
                        isVisible: true,
                        modifier: (rank_percentile, row) => {
                            // return ((row.rank_arrow === "up" ? `${rank}  <i class="fa fa-arrow-trend-up text-success"></i>` : ( row.rank_arrow === "down" ?  `${rank} <i class="fa fa-arrow-trend-down text-danger"></i>` : rank))) ;
                            return rank_percentile + "%";
                        }
                    },
                    {
                        title: this.$t('profile'),
                        type: 'component',
                        componentName: 'app-employee-media-object',
                        key: 'image',
                        modifier: (value, row) => {
                            return row.icon ? `${AppFunction.getBaseUrl()}/${row.icon.value.split('/').filter(d => d).join('/')}` : '';
                        }
                    },
                    {
                        title: this.$t('score'),
                        type: 'object',
                        key: 'total_balance',
                        isVisible: true,
                        modifier: (total_balance, row) => {
                            return total_balance ?? '-';
                        }
                    },
                    // {
                    //     title: this.$t('employee_id'),
                    //     type: 'object',
                    //     key: 'profile',
                    //     isVisible: true,
                    //     modifier: (value, row) => {
                    //         return value ? value.employee_id : '-';
                    //     }
                    // },
                    // {
                    //     title: this.$t('employment_status'),
                    //     type: 'component',
                    //     componentName: 'app-employee-status',
                    //     key: 'employment_status',
                    //     isVisible: true,
                    // },
                    {
                        title: this.$t('department'),
                        type: 'custom-html',
                        key: 'department',
                        isVisible: true,
                        modifier: (department) => {
                            return department ? department.name ? department.name : '-' : '-';
                        }
                    },
                    {
                        title: this.$t('last_updated'),
                        type: 'custom-html',
                        key: 'last_updated_at',
                        isVisible: true,
                        modifier: (last_updated) => {
                            return last_updated ? calenderTime(last_updated, true) : '-';
                        }
                    },
                    // {
                    //     title: this.$t('work_shift'),
                    //     type: 'object',
                    //     key: 'working_shift',
                    //     isVisible: true,
                    //     modifier: (work_shift, row) => {
                    //         return work_shift ? work_shift.name ? work_shift.name : '-' : '-';
                    //     }
                    // },
                    // {
                    //     title: this.$t('joining_date'),
                    //     type: 'object',
                    //     key: 'profile',
                    //     isVisible: true,
                    //     modifier: (value, row) => {
                    //         return value && value.joining_date ? calenderTime(value.joining_date, false) : this.$t('not_yet_joined');
                    //     }
                    // },
                    // {
                    //     title: this.$t('salary'),
                    //     type: 'object',
                    //     key: 'salary',
                    //     isVisible: true,
                    //     modifier: (salary, row) => {
                    //         return salary && salary.amount ? salary.amount : '-';
                    //     }
                    // },
                    // {
                    //     title: this.$t('role'),
                    //     type: 'object',
                    //     key: 'roles',
                    //     isVisible: true,
                    //     modifier: (roles) => {
                    //         let roleName = '';
                    //         roles.forEach((element, index) => {
                    //             roleName += index > 0 ? ', ' + element.name : element.name;
                    //         });
                    //         roleName = roleName ? roleName : '-';
                    //         return roleName;
                    //     }
                    // },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                actionType: "dropdown",
                actions: [],
                rowLimit: 10,
                paginationType: "pagination"
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
            employee: {},
        }
    },
    watch: {
        isModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        }
    },
    methods: {
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {
            this.promptIcon = action.icon;
            this.employeeId = row.id;
            this.modalClass = action.modalClass;

            if (action.key === 'view_details') {
                window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            }

            // if (action.key === 'edit') {
            //     this.selectedUrl = `${action.url}/${row.id}`;
            //     this.isModalActive = true;
            // }

            // if (action.key === 'cancel_invitation') {
            //     this.confirmationModalActive = true;
            //     this.promptAction = action.key;
            //     this.promptTitle = this.$t('are_you_sure');
            //     this.promptMessage = this.$t('you_are_going_to_cancel_an_invitation');
            // }

            // if (action.key === 'terminate') {
            //     this.confirmationModalActive = true;
            //     this.promptAction = action.key;
            //     this.promptTitle = this.$t('are_you_sure');
            //     this.promptMessage = this.$t('you_are_going_to_terminate_an_employee');
            // }

            // if (action.key === 'rejoining') {
            //     this.confirmationModalActive = true;
            //     this.promptAction = action.key;
            //     this.promptTitle = this.$t('are_you_sure');
            //     this.promptMessage = this.$t('you_are_permitting_an_employee_for_re_joining');
            // }

            // if (action.key === 'remove_from_employee') {
            //     this.confirmationModalActive = true;
            //     this.promptAction = action.key;
            //     this.promptTitle = this.$t('are_you_sure');
            //     this.promptMessage = this.$t('you_are_going_to_remove_an_employee_from_list');
            // }

            // if (action.key === 'assign_leave') {
            //     this.leaveModalActive = true;
            //     this.employee = row;
            // }

            // if (action.key === 'add_attendance') {
            //     this.attendanceModalActive = true;
            //     this.employee = row;
            // }

            // if (action.key === 'add_joining_date') {
            //     this.isJobHistoryEditModalActive = true;
            //     this.employee = row;
            //     this.modalAction = 'joining_date';
            // }
            //
            // if (action.key === 'add_or_edit_salary') {
            //     this.isJobHistoryEditModalActive = true;
            //     this.employee = row;
            //     this.modalAction = 'salary';
            // }
        },
        triggerConfirm() {
            // if (this.promptAction === 'cancel_invitation') {
            //     this.cancelInvitation();
            // }
            // if (this.promptAction === 'terminate') {
            //     this.terminate();
            // }
            // if (this.promptAction === 'rejoining') {
            //     this.rejoining();
            // }
            // if (this.promptAction === 'remove_from_employee') {
            //     this.removeEmployee();
            // }
        },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
        },
        // cancelInvitation() {
        //     this.loading = true;
        //     axiosDelete(`${EMPLOYEES}/${this.employeeId}/cancel-invitation`).then(({data}) => {
        //         this.confirmationModalActive = false;
        //         this.toastAndReload(data.message, 'employee-table');
        //     }).catch(({data}) => {
        //         this.confirmationModalActive = false;
        //         this.toastAndReload(data.message, 'employee-table');
        //     }).finally(() => this.closeConfirmation());
        // },
        // terminate() {
        //     this.loading = true;
        //     axiosPatch(`${EMPLOYEES}/${this.employeeId}/terminate`).then(({data}) => {
        //         this.confirmationModalActive = false;
        //         this.toastAndReload(data.message, 'employee-table');
        //         setTimeout(() => {
        //             this.isTerminationReasonModalActive = true;
        //         })
        //     }).catch(({data}) => {
        //         this.confirmationModalActive = false;
        //         this.toastAndReload(data.message, 'employee-table');
        //     }).finally(() => this.closeConfirmation());
        // },
        // rejoining() {
        //     this.confirmationModalActive = false;
        //     this.employmentStatusModalActive = true;
        // },
        reloadLeaderboardTable() {
            this.$hub.$emit('reload-leaderboard-table');
        },
        // removeEmployee() {
        //     this.loading = true;
        //     axiosPatch(`${TENANT_USERS}/${this.employeeId}/remove-from-employee`)
        //         .then(({data}) => {
        //             this.confirmationModalActive = false;
        //             this.toastAndReload(data.message, 'employee-table')
        //         }).catch(({response}) => {
        //         this.toastException(response.data)
        //         this.confirmationModalActive = false;
        //     }).finally(() => this.closeConfirmation());
        // }
    }
}
